import { useMemo } from 'react';
import './index.css';
import { Subscription } from '../../../../../types/subscription';
import {
  formatPercentage,
  formatPrice,
} from '../../../../../helpers/NumberFormatter';

interface Props {
  subscription: Subscription;
}
const Price: React.FC<Props> = (props: Props) => {
  const { subscription } = props;
  const { latestPrice, currentPriceChange, currentProfit, latestTransaction } =
    subscription;

  const deltaColor = useMemo(() => {
    if (!currentPriceChange) {
      return 'white';
    }

    return currentPriceChange > 0 ? 'green' : 'red';
  }, [currentPriceChange]);

  if (!latestPrice || !latestTransaction?.orderPrice) {
    return null;
  }

  const currentPriceChangeAbsolute =
    latestPrice - latestTransaction?.orderPrice;

  return (
    <div className="price-root">
      <div className="price-container">
        <span className="price-value">{formatPrice(latestPrice, true, 7)}</span>
      </div>
      <div className="price-delta-container">
        <span className="price-delta-absolute" style={{ color: deltaColor }}>
          {formatPrice(
            currentPriceChangeAbsolute || 0,
            true,
            7,
            false,
            'always',
          )}
        </span>
        <span className="price-delta-relative" style={{ color: deltaColor }}>
          {formatPercentage(currentPriceChange || 0)}
        </span>
      </div>
    </div>
  );
};

export default Price;
